/* ELC Shift — Schedule module (rota week-nav, shift editing, AI generate, CSV, compliance, rules).
   Extracted from index.html block #22 (Sprint 2) via AST. Behaviour-preserving: each function
   was a global inline declaration, so all are re-exposed on window — inline onclick handlers and
   the Rota render bundle resolve them exactly as before. App globals (DB, currentWeekStart,
   getStoreRoster, window.renderRotaWeek/getShift/loadShiftsFromDB …) are read at runtime. */
import { isProtectedLeave, skippedSummary, keptBackDays, coverLeaveMessage } from './leave-guard.js';   // v129.62 — publish never overwrites booked leave
// v136.8 - the ONE week_start + day -> date helper (docs/field-lessons.md "The Monday assumption"): it walks
// forward from whatever weekday week_start really is, so a Qatar week (Sunday) dates correctly and a UAE week
// (Monday) gives exactly what the old Mon-first offset gave.
import { rotaDayDate, aiWeekLabel } from './rota-dates.js';
import { SHIFT_TYPE_HELP } from './shift-type-help.js';
import { uiConfirm as sharedConfirm } from '../shared/confirm-dialog.js';   // v136.8: the TOIL part-day question (askToilPartDay)
import { weekendFor, peakDaysFor } from '../shared/rota-country.js';   // v133.94: Qatar's Friday-Saturday weekend
import { dedupeShiftRows } from '../shared/shift-dedupe.js';   // v136.12: one row per person and day in a publish
import { withTimeout, startTicker, AI_CALL_LIMIT_MS, AI_NOTES_LIMIT_MS, AI_SKIP_REFINE_SECS, TOO_SLOW } from '../shared/rota-wait.js';   // v133.94: no silent freeze   // v132.54 - what each shift type is FOR (one map: helper line + hover)
(function(){

function renderCurrentRotaView(){
  // v70: Always update the week label, regardless of which view is active.
  // Was previously only done inside renderRotaWeek — meaning Day View and
  // vs Actual would update their content on week-arrow click but the header
  // label stayed stuck on the previous week. Symptom: "arrows don't work."
  updateWeekLabel();
  if(currentView==='week')renderRotaWeek();else if(currentView==='day')renderDayView();
  else if(currentView==='cover'){if(typeof CoverView!=='undefined'&&CoverView.render)CoverView.render();}
  else renderVsActual();
  // v132.98: the cover check verdict above every view (advice only, fail-soft).
  if(typeof CoverView!=='undefined'&&CoverView.renderVerdict){try{CoverView.renderVerdict();}catch(e){}}
}

function updateWeekLabel(){
  var el = document.getElementById('weekLabel');
  if (!el) return;
  var wkEnd = new Date(currentWeekStart);
  wkEnd.setDate(wkEnd.getDate() + 6);
  el.textContent = currentWeekStart.toLocaleDateString('en-GB',{day:'numeric',month:'short'}) + ' \u2013 ' + wkEnd.toLocaleDateString('en-GB',{day:'numeric',month:'short'});
}

function changeWeek(dir){currentWeekStart=new Date(currentWeekStart);currentWeekStart.setDate(currentWeekStart.getDate()+dir*7);loadShiftsFromDB(currentWeekStart).finally(function(){renderCurrentRotaView();});}

async function loadFutureWeeksForProjections() {
  var now = Date.now();
  if (now - _futureShiftsLoadedAt < FUTURE_LOAD_TTL_MS) return;
  _futureShiftsLoadedAt = now;
  // v136.8: the store's OWN week start (Sunday in Qatar). getMonday loaded Monday weeks, which no Qatar row has.
  var base = (typeof getWeekStart === 'function') ? getWeekStart(new Date()) : getMonday(new Date());
  var promises = [];
  // Skip i=0 (current week) — already loaded.
  for (var i = 1; i <= FUTURE_WEEKS_TO_LOAD; i++) {
    var wkDate = new Date(base);
    wkDate.setDate(wkDate.getDate() + i * 7);
    var wkStr = localDateStr(wkDate);
    promises.push(loadShiftsFromDB(wkStr).catch(function(e){
      console.warn('[projections] week load failed:', e && e.message);
    }));
  }
  await Promise.all(promises);
  dlog('[projections] loaded ' + FUTURE_WEEKS_TO_LOAD + ' future weeks');
}

function requireManager(action){
  var args=Array.prototype.slice.call(arguments,1);
  executeAction.apply(null,[action].concat(args));
}

function executeAction(action){
  var args=Array.prototype.slice.call(arguments,1);
  if(action==='editShift')openShiftModal(args[0],args[1]);
  if(action==='editShift2')openShiftModal(args[0],args[1],2);   // v129.156 — the day's second leg
  if(action==='adjustToil')openToilModal(args[0]);
  if(action==='setDelivery')openDeliveryModal(args[0]);
  if(action==='openCoverAdd')openCoverAddModal();
}

function refreshCoverAddStaff(){
  var filter = document.getElementById('coverAddStoreFilter').value;
  var storeStaffIds = getStoreStaff(currentStore).map(function(s){return s.id;});
  // Candidates: active staff from other stores, optionally filtered to one store
  var candidates = ALL_STAFF.filter(function(s){
    if (s.active === false) return false;
    if (s.store === currentStore) return false;
    if (storeStaffIds.indexOf(s.id) !== -1) return false;
    if (filter && s.store !== filter) return false;
    return true;
  }).sort(function(a,b){return a.name.localeCompare(b.name);});
  var sel = document.getElementById('coverAddStaff');
  sel.innerHTML = '<option value="">Select someone\u2026</option>' +
    candidates.map(function(s){return '<option value="'+s.id+'">'+escapeHtml(s.name)+' ('+escapeHtml(s.store)+')</option>';}).join('');   // v132.85
}

function saveCoverAdd(){
  var sid = parseInt(document.getElementById('coverAddStaff').value);
  if (!sid) { showToast('Pick a staff member', 'error'); return; }
  var s = ALL_STAFF.find(function(x){return x.id === sid;});
  if (!s) { showToast('Staff not found', 'error'); return; }
  var days = Array.from(document.querySelectorAll('#coverAddDays input[type=checkbox]:checked')).map(function(cb){return cb.value;});
  if (!days.length) { showToast('Pick at least one day', 'error'); return; }
  var start = document.getElementById('coverAddStart').value;
  var finish = document.getElementById('coverAddFinish').value;
  var lunch = parseInt(document.getElementById('coverAddLunch').value) || 60;
  var lunchAt = document.getElementById('coverAddLunchAt').value || '13:00';
  if (!start || !finish) { showToast('Start and finish required', 'error'); return; }
  // Cap on-site time at 9h
  var onSite = shiftMins(start, finish) / 60;
  if (onSite > 9) finish = minsToTime(timeMins(start) + 540);

  var wkStr = localDateStr(currentWeekStart);
  var dbRows = [];
  var priorCells = {};   // v136.8: what each day held before, so a day the server keeps back is put back
  // v57: capture attribution for the whole batch
  var attr = getCurrentAttribution();
  days.forEach(function(day){
    var sk = wkStr + '_' + shiftKey(sid, day);
    priorCells[day] = shifts[sk];
    shifts[sk] = {type:'work', start:start, finish:finish, lunch:lunch, lunchAt:lunchAt, notes:'Cover from '+s.store, workStore:currentStore};
    var row = {
      staff_id: sid, week_start: wkStr, day: day, type: 'work',
      start_time: start, end_time: finish, lunch_at: lunchAt, lunch_mins: lunch,
      notes: 'Cover from '+s.store, work_store: currentStore,
      variance_toil: null,
    };
    if (attr) {
      row.edited_by_staff_id   = attr.staff_id;
      row.edited_by_staff_name = attr.staff_name;
    }
    dbRows.push(row);
  });
  var firstName = s.name.split(' ')[0];
  var putBack = function(list){
    list.forEach(function(day){
      var sk = wkStr + '_' + shiftKey(sid, day);
      if (priorCells[day] !== undefined) shifts[sk] = priorCells[day]; else delete shifts[sk];
    });
  };
  closeCoverAddModal();
  renderCurrentRotaView();
  renderClockScreen();
  if (typeof DB === 'undefined') return;
  // v136.8 (16 Oct audit): cover is now saved with the leave guard ON. Without it db.js told the server
  // allow_leave_overwrite, so a holiday, sick or TOIL day booked at the person's home store was silently
  // replaced by the cover shift (the same clobber v129.62/v129.84 closed for the AI publish). The server keeps
  // a booked-leave day back and saves the rest; the days it kept are the ones missing from what it returns.
  // A day that is NOT booked leave (work, off, empty) is saved exactly as before.
  // v57: ensure we have a session PIN before writing - prompt once if not
  return (attr ? Promise.resolve(attr) : requirePinForAttribution('adding cover shifts'))
    .then(function(a){
      // If attribution was captured AFTER building dbRows, patch them
      if (a && !attr) dbRows.forEach(function(r){ r.edited_by_staff_id = a.staff_id; r.edited_by_staff_name = a.staff_name; });
      return DB.shifts.save(dbRows, { guardLeave: true });
    })
    .then(function(saved){
      var kept = keptBackDays(dbRows, saved);
      dlog('[DB] Saved '+(dbRows.length - kept.length)+' cover shifts for '+s.name+(kept.length ? ' ('+kept.length+' kept back: booked leave)' : ''));
      if (kept.length) {
        putBack(kept);
        renderCurrentRotaView();
        renderClockScreen();
        showToast(coverLeaveMessage(firstName, kept, dbRows.length - kept.length), 'error');
        return;
      }
      showToast(firstName+' added as cover for '+days.length+' day'+(days.length>1?'s':''), 'success');
    }).catch(function(e){
      // Nothing was saved: put every day back the way it was.
      putBack(days);
      renderCurrentRotaView();
      renderClockScreen();
      var m = String((e && e.message) || '');
      if (m === 'Attribution cancelled' || /Authentication required/i.test(m)) {
        showToast('Cover save cancelled', 'error');
        return;
      }
      console.warn('[DB] Cover save failed:', m);
      showToast('Cover not saved'+(m ? ': '+m : '')+'. The rota is back as it was. Please try again.', 'error');
    });
}

function setVarianceReason(r){
  shiftVarianceReason=r;
  document.getElementById('tvBtnToil').classList.toggle('active',r==='toil');
  document.getElementById('tvBtnManager').classList.toggle('active',r==='manager');
  var diffH=parseFloat(document.getElementById('toilVarianceBox').dataset.diff)||0;
  if(r==='toil'){
    document.getElementById('tvNote').textContent=diffH>0?'+'+diffH.toFixed(1)+'h TOIL will be credited to employee':Math.abs(diffH).toFixed(1)+'h TOIL will be deducted — employee must make it up';
  }else if(r==='manager'){
    document.getElementById('tvNote').textContent='No TOIL impact. Reason stored in shift notes.';
  }
}

function checkShiftVariance(){
  if(currentShiftType!=='work')return;
  var start=document.getElementById('smStart').value;
  var finish=document.getElementById('smFinish').value;
  var lunch=parseInt(document.getElementById('smLunch').value)||60;
  if(!start||!finish)return;
  var worked=shiftMins(start,finish)/60-lunch/60;
  var diff=Math.round((worked-8)*10)/10; // positive = overtime, negative = undertime
  var box=document.getElementById('toilVarianceBox');
  if(diff===0){box.style.display='none';shiftVarianceReason=null;return;}
  box.style.display='block';
  box.dataset.diff=diff;
  document.getElementById('tvLabel').textContent=diff>0?'Overtime ('+diff.toFixed(1)+'h above contract)':'Short shift ('+Math.abs(diff).toFixed(1)+'h below contract)';
  document.getElementById('tvDiff').textContent=diff>0?'This shift is '+diff.toFixed(1)+'h longer than the standard 8h contracted day. How should the extra time be recorded?':'This shift is '+Math.abs(diff).toFixed(1)+'h shorter than the standard 8h contracted day. Pick TOIL if the employee owes the time, or "Agreed by Manager" if it\u2019s an approved one-off (e.g. relief cover with travel time).';
  document.getElementById('tvNote').textContent='';
  // Reset buttons if diff changed
  if(shiftVarianceReason){setVarianceReason(shiftVarianceReason);}
  else{document.getElementById('tvBtnToil').classList.remove('active');document.getElementById('tvBtnManager').classList.remove('active');}
}

function setShiftType(t){
  currentShiftType=t;
  // v48: explicit button-id map (avoids auto-generation bugs like 'atstore' -> 'stAtstore')
  var BTN_IDS = { work:'stWork', atstore:'stAtStore', off:'stOff', toil:'stToil', holiday:'stHoliday', sick:'stSick', apl:'stApl', oos:'stOos' };
  // atstore gets its own 'active-atstore' style — visually blue, distinct from amber 'active-oos'
  var ACTIVE_CLASS = { work:'active-work', atstore:'active-atstore', off:'active-off', toil:'active-toil', holiday:'active-holiday', sick:'active-sick', apl:'active-apl', oos:'active-oos' };
  Object.keys(BTN_IDS).forEach(function(x){
    var el=document.getElementById(BTN_IDS[x]);
    if(!el)return;
    el.className='st-btn'+(t===x?' '+ACTIVE_CLASS[x]:'');
    // v132.54: hover text from the same map as the helper line below, set here
    // rather than in a separate init pass so the two can never disagree.
    if(SHIFT_TYPE_HELP[x])el.title=SHIFT_TYPE_HELP[x];
  });
  // v132.54: what the SELECTED type is for. Always visible - see SHIFT_TYPE_HELP.
  var stHelpEl=document.getElementById('stHelp');
  if(stHelpEl)stHelpEl.textContent=SHIFT_TYPE_HELP[t]||'';
  // Time fields show for 'work' (at this store) OR 'atstore' (cover at another store)
  var showTimes = (t==='work' || t==='atstore');
  document.getElementById('shiftTimeFields').style.display=showTimes?'flex':'none';
  document.getElementById('shiftTimeFields').style.flexDirection='column';
  document.getElementById('shiftTimeFields').style.gap='10px';
  // v129.15 APL: the reason select shows only for Authorised Paid Leave
  var aplEl = document.getElementById('aplReasonField');
  if (aplEl) {
    aplEl.style.display = t==='apl' ? 'flex' : 'none';
    aplEl.style.flexDirection = 'column';
    aplEl.style.gap = '4px';
  }
  // v132.48 — TOIL hours: only meaningful on a TOIL day.
  var toilHrsEl = document.getElementById('toilHoursField');
  if (toilHrsEl) {
    toilHrsEl.style.display = t==='toil' ? 'flex' : 'none';
    toilHrsEl.style.flexDirection = 'column';
    toilHrsEl.style.gap = '4px';
  }
  document.getElementById('oosStoreField').style.display=t==='oos'?'flex':'none';
  document.getElementById('oosStoreField').style.flexDirection='column';
  document.getElementById('oosStoreField').style.gap='4px';
  var atEl = document.getElementById('atStoreField');
  if (atEl) {
    atEl.style.display = t==='atstore' ? 'flex' : 'none';
    atEl.style.flexDirection = 'column';
    atEl.style.gap = '4px';
  }
  if(t!=='work' && t!=='atstore'){document.getElementById('toilVarianceBox').style.display='none';shiftVarianceReason=null;}
  else{checkShiftVariance();}
}

function openShiftModal(staffId,day,seq){
  // Guard: past weeks are read-only. If currentWeekStart is before this week, refuse.
  var thisWeekStart = getWeekStart(new Date());
  if (currentWeekStart < thisWeekStart) {
    showToast('Past weeks are read-only — edit the current or future weeks only', 'info');
    return;
  }
  // Reuse the cached editor if we already authenticated this tab visit
  if (_rotaEditorName) {
    _openShiftModalInner(staffId, day, _rotaEditorName, seq);
    return;
  }
  requestEditPin(function(editorName){
    _rotaEditorName = editorName; // cache for this rota session
    _openShiftModalInner(staffId, day, editorName, seq);
  });
}

function requestEditPin(callback){
  _pendingEditCallback=callback;
  document.getElementById('editPinInput').value='';
  document.getElementById('editPinErr').style.display='none';
  document.getElementById('editPinModal').style.display='flex';
  setTimeout(function(){document.getElementById('editPinInput').focus();},100);
}

async function submitEditPin(){
  var pin=(document.getElementById('editPinInput').value||'').trim();
  var store = currentUser && currentUser.store;
  // Area managers / admins might land here too — they don't have a single
  // store. Skip the lookup gracefully in that case.
  if (!store) {
    document.getElementById('editPinErr').style.display='block';
    document.getElementById('editPinErr').textContent='No store context for PIN lookup';
    return;
  }
  if (!pin || pin.length < 4) {
    document.getElementById('editPinErr').style.display='block';
    document.getElementById('editPinErr').textContent='Enter a valid PIN';
    return;
  }
  // v59: server-side lookup. Was: ALL_STAFF.find(s => s.pin === pin).
  try {
    var data = await DB.staff.findByPin(store, pin);
    if (!data || !data.id) {
      document.getElementById('editPinErr').style.display='block';
      document.getElementById('editPinErr').textContent='PIN not recognised — try again';
      document.getElementById('editPinInput').value='';
      return;
    }
    document.getElementById('editPinModal').style.display='none';
    if(_pendingEditCallback)_pendingEditCallback(data.name);
    _pendingEditCallback=null;
  } catch(e) {
    var msg = String(e && e.message || '');
    var rateLimited = msg.indexOf('Too many') !== -1 || msg.indexOf('429') !== -1;
    document.getElementById('editPinErr').style.display='block';
    document.getElementById('editPinErr').textContent = rateLimited
      ? 'Too many attempts — wait a minute'
      : 'Connection error — try again';
    document.getElementById('editPinInput').value='';
  }
}

function cancelEditPin(){
  // v73: replaces the old skipEditPin. Cancel discards the edit entirely
  // rather than fake-attributing it as "Unknown" — closes an audit-trail hole
  // that mattered at pilot scale and would matter more at 28 stores.
  document.getElementById('editPinModal').style.display='none';
  // Don't invoke the callback — the pending edit is dropped.
  _pendingEditCallback=null;
}

function _openShiftModalInner(staffId,day,editorName,seq){
  // v129.156 (split shifts) — seq 2 edits the day's SECOND leg, held in the
  // parallel shifts2 map. Everything else in the modal behaves identically.
  var isLeg2=(seq===2);
  editingShift={staffId:staffId,day:day,editedBy:editorName||'Unknown',seq:isLeg2?2:1};
  var numId=parseInt(staffId);
  var s=ALL_STAFF.find(function(x){return x.id===numId;});
  if(!s){closeShiftModal();showToast('Staff member not found','error');return;}
  var sk=shiftKey(staffId,day);
  // Also check the week-scoped key (v48: all shifts are week-scoped in DB)
  var wkStr=localDateStr(currentWeekStart);
  var wkSk=wkStr+'_'+sk;
  var sh=isLeg2?(shifts2[wkSk]||shifts2[sk]):(shifts[wkSk]||shifts[sk]);
  if(isLeg2&&sh&&sh.type!=='work')sh=undefined;   // a removed (type off) leg 2 reopens as Add
  document.getElementById('smTitle').textContent=isLeg2?(sh?'Edit 2nd Shift':'Add 2nd Shift'):(sh?'Edit Shift':'Add Shift');
  // The "second shift…" link shows only in leg-1 mode (no third legs for now).
  var splitRow=document.getElementById('smSplitRow');
  if(splitRow)splitRow.style.display=isLeg2?'none':'block';
  document.getElementById('smSub').textContent=s.name.split(' ')[0]+' \u2014 '+DAY_FULL[day];
  // Infer initial type: if this is a 'work' shift with a workStore different from currentStore,
  // treat it as 'atstore' so the picker is shown.
  var initialType = sh && sh.type ? sh.type : 'work';
  if (initialType === 'work' && sh && sh.workStore && sh.workStore !== currentStore) {
    initialType = 'atstore';
  }
  currentShiftType=initialType;
  // v129.68: a shift whose variance was already approved as TOIL reopens with
  // TOIL pre-selected — the manager fixing a lunch or a note is no longer
  // re-prompted to re-approve (the re-prompt was half of the double-credit
  // bug; the other half, the stored delta, is gone — see saveShift).
  shiftVarianceReason=(sh && sh.varianceToil)?'toil':null;
  document.getElementById('toilVarianceBox').style.display='none';
  document.getElementById('tvBtnToil').classList.remove('active');
  document.getElementById('tvBtnManager').classList.remove('active');
  setShiftType(currentShiftType);
  document.getElementById('smStart').value=(sh&&sh.start)||'09:00';
  document.getElementById('smFinish').value=(sh&&sh.finish)||'18:00';
  document.getElementById('smLunch').value=String((sh&&sh.lunch)||60);
  document.getElementById('smLunchAt').value=(sh&&sh.lunchAt)||'13:00';
  document.getElementById('smNotes').value=(sh&&sh.notes)||'';
  var oosSel=document.getElementById('smOosStore');
  // v48: this field is now a free-text input (was a dropdown pre-v48). Just set its value.
  oosSel.value = (sh && sh.oosStore) ? sh.oosStore : '';
  // v132.48: re-opening a TOIL day restores its hours (blank = a whole day)
  var thSel=document.getElementById('smToilHours');
  if (thSel) thSel.value = (sh && sh.toilHours != null) ? String(sh.toilHours) : '';
  // v129.15: re-opening an APL day restores its reason
  var aplSel=document.getElementById('smAplReason');
  if (aplSel) aplSel.value = (sh && sh.leaveReason) ? sh.leaveReason : '';
  // v133.39: the stores table too, not only stores that have staff loaded here: a store with no staff in
  // ALL_STAFF was missing from "Working at which store?" (staff bug report, 3 Oct 2026: Reem Mall). The same
  // class getMyStores fixed in v80.16. A union, so every store listed before is still listed.
  var activeStores=(typeof ALL_STORES!=='undefined'&&Array.isArray(ALL_STORES)?ALL_STORES:[]).filter(function(s){return s&&s.name&&s.active!==false;}).map(function(s){return s.name;});
  var allStoreNames=[...new Set(ALL_STAFF.map(function(x){return x.store;}).concat(activeStores))].filter(Boolean).sort();
  // v48: populate the "At Another Store" picker with all stores except currentStore
  var atSel=document.getElementById('smAtStore');
  if (atSel) {
    atSel.innerHTML='<option value="">Select a store…</option>';
    allStoreNames.filter(function(x){return x!==currentStore;}).forEach(function(x){
      var o=document.createElement('option');o.value=x;o.textContent=x;
      if (sh && sh.workStore && sh.workStore === x) o.selected = true;
      atSel.appendChild(o);
    });
  }
  // Check variance on open (for existing shifts that were already non-standard)
  setTimeout(checkShiftVariance,0);
  document.getElementById('shiftModal').classList.add('open');
}

function closeShiftModal(){document.getElementById('shiftModal').classList.remove('open');editingShift=null;shiftVarianceReason=null;}

// v136.8: the part-hours TOIL Day question (see saveShift). true = "Set working hours" (the old OK), false = "Keep TOIL
// Day" (the old Cancel; also Escape and a tap outside, as the browser's box treated them).
function trS(s){return (typeof I18N!=='undefined'&&I18N.t)?I18N.t(s):s;}
function askToilPartDay(th){
  var ask=(typeof window!=='undefined'&&typeof window.uiConfirm==='function')?window.uiConfirm:sharedConfirm;
  return ask(trS('Is this person working for part of today?')+'\n\n'
    +trS('Set working hours: choose their shorter hours, then TOIL as the reason for the missing hours. They can clock in as normal.')+'\n\n'
    +trS('Keep TOIL Day: they are off all day, and the hours come off their TOIL.')+' ('+th+'h)',
    {confirmLabel:trS('Set working hours'),cancelLabel:trS('Keep TOIL Day')});
}
// v136.8: async because the TOIL part-day question above waits for an answer. Every caller ignores the return value
// (index.html's Save button, window.saveShift), and nothing else in here awaits, so every other path runs as before.
async function saveShift(){
  // v127.9: a double-tap on Save fires this again AFTER closeShiftModal()
  // nulled editingShift (crash reported from Dubai - Arabian Ranches 2,
  // 22 Jul). The first tap already saved; the second is a no-op.
  if(!editingShift)return;
  var staffId=editingShift.staffId;var day=editingShift.day;
  // v48: All shifts are per-staff-per-week-per-day, always keyed YYYY-MM-DD_sid_day.
  // No more 'c<id>_<day>' cover keys — cross-store placement uses workStore field.
  var wkStr=localDateStr(currentWeekStart);
  var sk=wkStr+'_'+shiftKey(staffId,day);
  // v129.156 (split shifts) — leg-2 mode. The type branches below write to
  // shifts[sk] verbatim (deliberately untouched: they are the load-bearing
  // v79/v80 balance logic); in leg-2 mode we snapshot leg 1 first and MOVE the
  // branch's result into shifts2 afterwards, restoring leg 1. A second leg can
  // only be Work / At Another Store — the day's leave status lives on leg 1 —
  // and choosing Day Off is how a second leg is REMOVED (an inert seq-2 'off'
  // row: renders nothing, computes nothing in the per-day maths).
  var isLeg2=(editingShift.seq===2);
  if(isLeg2&&['work','atstore','off'].indexOf(currentShiftType)===-1){
    showToast('A second shift can be Work or At Another Store (choose Day Off to remove it)','error');
    return;
  }
  var _preLeg1=isLeg2?shifts[sk]:undefined;
  var _preLeg2=isLeg2?shifts2[sk]:undefined;

  // v79.15.1 — capture the EXISTING shift before overwriting so we can compute
  // proper balance deltas. Two bugs this fixes:
  //   1. Re-saving a holiday/sick/toil shift used to decrement the balance
  //      again (silent double-count: open shift → save → save again → -2 days).
  //   2. Changing a holiday/sick/toil shift back to work/off used to leak the
  //      balance entirely (the day was deducted on the original save, never
  //      re-credited when the type changed).
  // Approach: per-branch guards (oldType !== newType) prevent double-count.
  // After the type branches, a re-credit block runs when oldType was a
  // deducted type and newType isn't.
  var oldShift = shifts[sk];
  var oldType  = (oldShift && oldShift.type) || null;
  var _undoLocalToil=null;   // v136.8: the local variance-TOIL entry this save added, if any
  if(currentShiftType==='off'){shifts[sk]={type:'off',workStore:currentStore};}
  else if(currentShiftType==='toil'){
    // v80.16: TOIL deduction removed. The deduction is computed by
    // /api/balances reading the rota directly. Same simplification as
    // holiday/sick below.
    //
    // v132.48 (the ops manager): that deduction used to be a flat 8h per TOIL day,
    // so five banked hours minus one TOIL day left minus three. The day can
    // now carry HOURS. Blank means a whole day, which is still 8, so an
    // untouched TOIL day behaves exactly as it always did.
    var thEl=document.getElementById('smToilHours');
    var thRaw=thEl?String(thEl.value||'').trim():'';
    var th=thRaw===''?null:parseFloat(thRaw);
    if(th!==null && (!isFinite(th) || th<=0 || th>24)){
      showToast('TOIL hours must be between 0.5 and 24 — leave blank for a whole day','error');return;
    }
    // v132.94 (RAK and an area manager, 28-29 Sep 2026): a TOIL Day with 2 hours was
    // being used for "works most of the day, 2h TOIL". A TOIL Day means OFF
    // all day, so the rota showed a full TOIL day and the clock screen would
    // not let them clock in. The part-day route already exists: a shorter
    // work shift with TOIL picked as the reason for the missing hours. Ask.
    // v136.8 (accessibility audit): the Shift dialog with the two answers named, in the app's language, instead of the
    // browser's English OK/Cancel. "Set working hours" is the old OK (true); "Keep TOIL Day", Escape or a tap outside
    // is the old Cancel (false), which keeps the TOIL Day exactly as before.
    if(th!==null && th<8){
      var partDay=await askToilPartDay(th);
      if(partDay){
        setShiftType('work');
        showToast('Set their working hours, then choose TOIL as the reason for the missing hours','info');
        return;
      }
    }
    shifts[sk]={type:'toil',workStore:currentStore,toilHours:th};
  }
  else if(currentShiftType==='holiday'){
    shifts[sk]={type:'holiday',notes:document.getElementById('smNotes').value,workStore:currentStore};
    // v80.16: balance decrement removed. Holiday balance is now COMPUTED
    // from the rota by /api/balances on every read — no state to maintain
    // here, no drift possible. See worker.js GET /api/balances for the model.
  }
  else if(currentShiftType==='sick'){
    shifts[sk]={type:'sick',notes:document.getElementById('smNotes').value,workStore:currentStore};
    // v80.16: balance decrement removed. See holiday case above.
  }
  else if(currentShiftType==='apl'){
    // v129.15 (an area manager's idea) — Authorised Paid Leave: paid, on the rota,
    // deducts from NOTHING (balances-calc counts specific types; apl is
    // deliberately not one of them). Reason is REQUIRED: the HO usage report
    // groups on it, and "who is using it" is the abuse guard Matt asked for.
    var aplReason=document.getElementById('smAplReason')?document.getElementById('smAplReason').value:'';
    if(!aplReason){showToast('Pick a reason for Authorised Paid Leave','error');return;}
    if(aplReason==='other' && !document.getElementById('smNotes').value.trim()){showToast('Explain the leave in the notes when the reason is Other','error');return;}
    shifts[sk]={type:'apl',leaveReason:aplReason,notes:document.getElementById('smNotes').value,workStore:currentStore};
  }
  else if(currentShiftType==='oos'){shifts[sk]={type:'oos',oosStore:document.getElementById('smOosStore').value,notes:document.getElementById('smNotes').value,workStore:currentStore};}
  else if(currentShiftType==='atstore'){
    // v48: Working at another store today. Shift type stays 'work' in the data model,
    // but workStore is set to the target. This person will appear on the target
    // store's rota; their home store will show "↗ Target" chip.
    var atStart=document.getElementById('smStart').value;
    var atFinish=document.getElementById('smFinish').value;
    var atLunch=parseInt(document.getElementById('smLunch').value)||60;
    var atLunchAt=document.getElementById('smLunchAt').value||'13:00';
    var atNotes=document.getElementById('smNotes').value;
    var atTarget=document.getElementById('smAtStore').value;
    if (!atTarget) { showToast('Please pick a store', 'error'); return; }
    // Cap on-site time at 9h
    var atOnSite=shiftMins(atStart,atFinish)/60;
    if(atOnSite>9)atFinish=minsToTime(timeMins(atStart)+540);
    shifts[sk]={type:'work',start:atStart,finish:atFinish,lunch:atLunch,lunchAt:atLunchAt,notes:atNotes,workStore:atTarget};
  }
  else{
    var start=document.getElementById('smStart').value;var finish=document.getElementById('smFinish').value;
    var lunch=parseInt(document.getElementById('smLunch').value)||60;var lunchAt=document.getElementById('smLunchAt').value||'13:00';
    var notes=document.getElementById('smNotes').value;
    var weekHrs=getWeekHours(staffId);
    var workedHrs=shiftMins(start,finish)/60-lunch/60;
    var newHrs=Math.min(8,workedHrs); // capped for weekly check
    if(weekHrs+newHrs>48)showToast('Warning: over 48h this week','error');
    // Cap on-site time at 9h — UNLESS a manager has explicitly approved the
    // over-contract variance (TOIL / "Agreed by Manager", set just below).
    // Any >9h on-site shift forces the variance prompt (the gate below returns
    // early if no reason is chosen), so an UNapproved over-long shift can never
    // save — but an APPROVED one now keeps its full hours instead of silently
    // snapping back (Wafi City: 2pm→12am was reverting to 2pm→11pm).
    var onSite=shiftMins(start,finish)/60;
    if(onSite>9 && !shiftVarianceReason)finish=minsToTime(timeMins(start)+540);
    // Handle variance TOIL
    var diff=Math.round((workedHrs-8)*10)/10;
    var varianceToil=false;
    if(diff!==0){
      if(!shiftVarianceReason){showToast('Please choose TOIL or Agreed by Manager for the variance','error');return;}
      if(shiftVarianceReason==='toil'){
        // v129.68 \u2014 compute-on-read (the v80.16 pattern, at last, for variance
        // TOIL \u2014 6 Aug audit PAY HIGH). The row itself now carries
        // variance_toil=true and GET /api/balances credits the signed
        // (workedHrs \u2212 8) from the flagged row on every read \u2014 so re-saving the
        // same shift can never double-credit: there is no stored delta to
        // accumulate. The addToilTx below is LOCAL-ONLY (trailing auto=true
        // skips the DB persist, exactly like rota-visible TOIL days) and fires
        // only on the CHANGE vs what the row already carried, so a
        // reopen-to-fix-notes re-save adds nothing locally either.
        varianceToil=true;
        var vSid=parseInt(staffId);
        var vDate=rotaDayDate(wkStr,day);   // v136.8: was a Mon-first offset; a Qatar week starts on Sunday
        var priorDiff=(oldShift && oldShift.varianceToil && oldType==='work' && oldShift.start && oldShift.finish)
          ? Math.round(((shiftMins(oldShift.start,oldShift.finish)-(oldShift.lunch||0))/60-8)*10)/10
          : 0;
        var localDelta=Math.round((diff-priorDiff)*10)/10;
        if(vDate && localDelta!==0){
          if(localDelta>0){
            addToilTx(vSid,'add',localDelta,vDate,'Overtime worked ('+start+'\u2013'+finish+')',true);
          }else{
            addToilTx(vSid,'deduct',Math.abs(localDelta),vDate,'Short shift ('+start+'\u2013'+finish+')',true);
          }
          // v136.8: remembered so a save the server refuses takes this local entry back out too.
          _undoLocalToil={sid:vSid,delta:localDelta,tx:(typeof toilTransactions!=='undefined'&&Array.isArray(toilTransactions))?toilTransactions[0]:null};
        }
      }else{
        notes=(notes?notes+' | ':'')+'Variance agreed by manager ('+diff+'h)';
      }
    }
    shifts[sk]={type:'work',start:start,finish:finish,lunch:lunch,lunchAt:lunchAt,notes:notes,workStore:currentStore,varianceToil:varianceToil||undefined};
  }

  // v80.16 — Bug B refactor: re-credit blocks removed.
  // Previously, when a shift type changed AWAY from holiday/sick/toil, we
  // had to re-credit the balance to undo the earlier decrement (e.g. manager
  // marks Tue as Holiday → balance −1, manager changes their mind to Work →
  // balance +1). Now that balance is COMPUTED from rota every read, this
  // round-trip arithmetic is unnecessary. The next /api/balances fetch will
  // see the updated rota and return the correct balance directly.
  //
  // The decrement-and-re-credit dance was the source of v79.15.1's drift
  // bugs (a staff member's +24h pending TOIL, Dar Al Salam holiday 29/USED 1).
  // No state to maintain → no drift possible.

  // Record who made this change
  // v57: prefer session PIN attribution (verifiable), fall back to freeform "editedBy" for back-compat
  var attr = getCurrentAttribution();
  var editor = (attr && attr.staff_name) || editingShift.editedBy || 'Unknown';
  var editorStaffId = attr ? attr.staff_id : null;
  var changeTime=new Date().toLocaleTimeString('en-GB',{hour:'2-digit',minute:'2-digit'});
  // v129.156 — leg-2 mode: move the branch's result into shifts2 and restore
  // leg 1 (see the snapshot at the top of this function).
  if(isLeg2){
    shifts2[sk]=shifts[sk];
    if(_preLeg1!==undefined)shifts[sk]=_preLeg1;else delete shifts[sk];
  }
  var savedSh=isLeg2?shifts2[sk]:shifts[sk];
  savedSh.editedBy=editor;
  savedSh.editedAt=changeTime;
  // v48: ALL shifts persist to DB now (no more local-only cover). work_store is stamped on every row.
  try {
    var shObj = savedSh;
    var notesWithMeta = (shObj.notes || '') + (editor ? ' [edited by '+editor+' at '+changeTime+']' : '');
    var row = {
      staff_id: parseInt(staffId),
      week_start: wkStr,
      day: day,
      type: shObj.type,
      start_time: shObj.start || null,
      end_time: shObj.finish || null,
      lunch_at: shObj.lunchAt || null,
      lunch_mins: shObj.lunch || 0,
      notes: notesWithMeta,
      work_store: shObj.workStore || currentStore,
      // v129.15: WHY for an APL day (null for every other type)
      leave_reason: shObj.leaveReason || null,
      // v129.68: manager-approved TOIL variance travels ON the row (compute-
      // on-read). ALWAYS present — an explicit null clears a stale flag on
      // re-save (merge-duplicates preserves columns a row doesn't carry).
      variance_toil: shObj.varianceToil || null,
      // v132.48 — hours for a TOIL day. null means a whole day, which the
      // balance maths still treats as 8, so an untouched TOIL day behaves
      // exactly as it did before. ALWAYS present, so re-saving a part-day
      // TOIL back to a full day clears the old value rather than leaving a
      // stale one behind (merge-duplicates keeps columns a row omits).
      toil_hours: (shObj.type === 'toil' && shObj.toilHours > 0) ? shObj.toilHours : null,
      // v129.156 — the leg number. 1 for every ordinary shift (explicit, so a
      // re-save of leg 1 can never collide with a leg 2); 2 for a split day's
      // second leg. The Worker upserts on (staff_id, week_start, day, seq).
      seq: isLeg2 ? 2 : 1,
    };
    // v57: attach verified attribution if we have one
    if (editorStaffId) {
      row.edited_by_staff_id   = editorStaffId;
      row.edited_by_staff_name = editor;
    }
    // v136.8 (16 Oct audit): the save is AWAITED. It used to say "Shift saved" before the server answered, and a
    // refused save only reached the console while the grid kept showing a shift that was never stored. Now the
    // success toast waits for the server, and a refusal puts the rota back exactly as it was and says so.
    var _restoreShift=function(){
      if(isLeg2){
        if(_preLeg2!==undefined)shifts2[sk]=_preLeg2;else delete shifts2[sk];
      }else{
        if(oldShift!==undefined)shifts[sk]=oldShift;else delete shifts[sk];
      }
      if(_undoLocalToil){
        try{
          if(typeof toilBalances!=='undefined'&&toilBalances)toilBalances[_undoLocalToil.sid]=(toilBalances[_undoLocalToil.sid]||0)-_undoLocalToil.delta;
          if(_undoLocalToil.tx&&typeof toilTransactions!=='undefined'&&Array.isArray(toilTransactions)){
            var _ti=toilTransactions.indexOf(_undoLocalToil.tx);if(_ti!==-1)toilTransactions.splice(_ti,1);
          }
        }catch(_e){ /* display-only ledger: the undo must never throw */ }
      }
    };
    closeShiftModal();
    renderCurrentRotaView();renderClockScreen();
    return DB.shifts.save([row]).then(function(){
      showToast('Shift saved — '+editor+' at '+changeTime,'success');
      // v132.98: a gentle cover-check note for that day, after the saved toast.
      if(typeof CoverView!=='undefined'&&CoverView.afterSave){setTimeout(function(){CoverView.afterSave(day);},2500);}
      // v80.16: Re-fetch balances after any shift save so the Balances screen
      // reflects the new state. /api/balances is computed from rota (adding/
      // removing/changing a holiday/sick/toil/PH-work shift directly affects the
      // returned numbers). Cheap GET, fires async, no UI blocking.
      if (typeof refreshBalances === 'function') refreshBalances();
    }).catch(function(e){
      var m=String((e&&e.message)||'');
      // v129.156: pre-v198-1 DB: the legacy one-row-per-day unique refuses a
      // second leg with a duplicate-key error. Say exactly what that means and
      // roll the local state back so the grid never shows a leg the DB refused.
      if(isLeg2&&/23505|duplicate key|v198-0|v198-1|Split shifts/i.test(m)){
        if(_preLeg2!==undefined)shifts2[sk]=_preLeg2;else delete shifts2[sk];
        showToast('Split shifts are not switched on yet (migration v198-1) — the second shift was NOT saved','error');
        renderCurrentRotaView();
        return;
      }
      _restoreShift();
      renderCurrentRotaView();renderClockScreen();
      // A cancelled PIN is not a failure: nothing was saved and nothing changed.
      if(/Authentication required|Attribution cancelled/i.test(m)){
        showToast('Shift not saved: the PIN was not entered. The rota has not changed.','info');
        return;
      }
      console.warn('[DB] Shift save failed:', m);
      showToast('Shift not saved'+(m?': '+m:'')+'. The rota is back as it was. Please try again.','error');
    });
  } catch(e) {
    // v136.8: building the row threw, so nothing was sent: put the rota back and say so.
    console.warn('[DB] Shift save error:', e && e.message);
    if(isLeg2){ if(_preLeg2!==undefined)shifts2[sk]=_preLeg2;else delete shifts2[sk]; }
    else if(oldShift!==undefined)shifts[sk]=oldShift;else delete shifts[sk];
    closeShiftModal();
    renderCurrentRotaView();
    showToast('Shift not saved. The rota is back as it was. Please try again.','error');
  }
}

function getWeekHours(staffId){
  return DAYS.reduce(function(tot,day){
    var key=shiftKey(staffId,day);
    var sh=shifts[key];
    // v129.156 (split shifts) — the day's second leg counts toward the weekly
    // contract check too: a split day is MORE worked time, and the 48h warning
    // exists precisely to catch that.
    var sh2=(typeof shifts2!=='undefined')?shifts2[key]:undefined;
    if(sh2&&sh2.start&&sh2.type==='work'){
      tot+=Math.min(8,shiftMins(sh2.start,sh2.finish)/60-(sh2.lunch||60)/60);
    }
    if(!sh||!sh.start||(sh.type!=='work'&&sh.type!=='oos'))return tot;
    return tot+Math.min(8,shiftMins(sh.start,sh.finish)/60-(sh.lunch||60)/60);
  },0);
}

// Paid hours for a single shift — the number that lands in the payroll CSV's
// `paid_hours` column. Distinct from getWeekHours' weekly view: this is NOT
// capped at 8 (a 10h work day pays 9 after a 1h lunch), TOIL/holiday/sick pay
// the 8h contracted day, and everything else (off / oos) pays 0. Pure, so it
// can be unit-tested (Rung ②); used by the rota CSV export below.
function paidHoursForShift(sh){
  if(!sh) return 0;
  if(sh.type==='work' && sh.start && sh.finish){
    var onSite = shiftMins(sh.start, sh.finish) / 60;
    return Math.max(0, onSite - (sh.lunch||60)/60);
  }
  // v129.18: 'apl' pays the contracted day like the other paid absences. It was
  // MISSED in v129.15 and fell through to 0 — an "Authorised PAID Leave" day
  // exported paid_hours=0.00 to payroll, which is the inverse of the bug the
  // feature exists to fix (it moved the loss from the balance to the pay line).
  if(sh.type==='toil' || sh.type==='holiday' || sh.type==='sick' || sh.type==='apl') return 8;
  return 0;
}

async function runAiAnalysis(){
  var status=document.getElementById('aiAnalyseStatus');
  var result=document.getElementById('aiAnalyseResult');
  status.innerHTML='<div class="ai-dot"></div><div class="ai-dot"></div><div class="ai-dot"></div> Analysing rotas across your stores...';
  result.innerHTML='';

  var myStores=getMyStores();
  var wkStr=localDateStr(currentWeekStart);
  var displayDays=getDisplayDays();

  // Build a summary of all rotas
  var rotaSummary=myStores.map(function(store){
    var staff=getStoreStaff(store);
    var targets=getTargets(store,currentWeekStart);
    var lines=displayDays.map(function(day,i){
      var working=staff.filter(function(s){
        var sh=getShift(s.id,day,currentWeekStart);
        return !sh||sh.type==='work';
      });
      var off=staff.length-working.length;
      var hasClose=working.some(function(s){
        var sh=getShift(s.id,day,currentWeekStart);
        return sh&&sh.finish&&(sh.finish==='22:00'||sh.finish==='24:00');
      });
      var target=targets[day]||0;
      var spwh=working.length>0?Math.round(target/(working.length*8)):0;
      return day+': '+working.length+' working, '+off+' off, SPWH AED'+spwh+(hasClose?', close ✓':', NO CLOSE ⚠️');
    }).join('; ');
    return store+' ('+staff.length+' staff): '+lines;
  }).join('\n\n');

  var prompt='You are analysing weekly rotas for ELC cosmetics stores.\n\n'+
    'Week: '+localDateStr(currentWeekStart)+'\n\n'+
    'ROTA SUMMARY:\n'+rotaSummary+'\n\n'+
    'Please provide:\n'+
    '1. Any stores with NO close cover on any day (this is critical)\n'+
    '2. Days where SPWH (AED per worked hour) is very high (>400) suggesting understaffing\n'+
    '3. Stores with too many staff off on the same day\n'+
    '4. Any patterns or recommendations for improving coverage\n'+
    'Be concise and actionable. Use bullet points. Flag critical issues first.';

  try{
    var data=await DB.ai.rota({model:'claude-haiku-4-5-20251001',max_tokens:1000,
        system:'You are a retail operations analyst. Be concise and direct. Use bullet points.',
        messages:[{role:'user',content:prompt}]});
    var text=(data.content&&data.content[0]&&data.content[0].text)||'';
    status.innerHTML='✅ Analysis complete';
    // Convert markdown bullets to HTML
    result.innerHTML=escapeHtml(text).replace(/\*\*(.*?)\*\*/g,'<strong>$1</strong>').replace(/^[•\-\*] /gm,'<br>• ').replace(/\n/g,'<br>');   // v132.89: model text escaped before formatting
  }catch(err){
    status.innerHTML='❌ '+err.message;
  }
}

function getComplianceData(){
  var from=document.getElementById('compFrom')?.value||'';
  var to=document.getElementById('compTo')?.value||'';
  var storeFilter=document.getElementById('clAdminStore')?.value||'';
  var typeFilter=document.getElementById('clAdminType')?.value||'';
  var myStores=getMyStores();
  var rows=[];

  // Prefer DB rows; fall back to localStorage if cache empty (offline/old data).
  var seen = {}; // key `store|date|type` → true, to avoid duplicates when merging

  (_adminChecklistCache || []).forEach(function(rec){
    var store = rec.store, date = rec.date, type = rec.type;
    if (!store || !date || !type) return;
    if (!myStores.includes(store)) return;
    if (storeFilter && store !== storeFilter) return;
    if (typeFilter && type !== typeFilter) return;
    if (from && date < from) return;
    if (to && date > to) return;
    var items = rec.items || {};
    var answers = items.answers || {};
    var total = items.total || Object.keys(answers).length;
    var score = items.score != null
      ? items.score
      : Object.values(answers).filter(function(a){ return a && a.answer === 'yes'; }).length;
    var pct = total > 0 ? Math.round(score/total*100) : 0;
    var missed = [];
    Object.entries(answers).forEach(function(e){
      var v = e[1];
      if (!v || (v.answer && v.answer !== 'yes')) missed.push(String(parseInt(e[0])+1));
    });
    rows.push({
      store: store, date: date, type: type,
      completed: score, total: total, pct: pct,
      submittedBy: rec.completed_by || items.staff_name || '—',
      submittedAt: items.submitted_at || rec.completed_at || '—',
      missed: missed
    });
    seen[store + '|' + date + '|' + type] = true;
  });

  // Merge in anything from localStorage that isn't already in the DB cache
  for(var i=0;i<localStorage.length;i++){
    var key=localStorage.key(i);
    if(!key||!key.startsWith('elc_cl_'))continue;
    var withoutPrefix=key.replace('elc_cl_','');
    var lastUnderscore=withoutPrefix.lastIndexOf('_');
    var secondLastUnderscore=withoutPrefix.lastIndexOf('_',lastUnderscore-1);
    if(lastUnderscore<0||secondLastUnderscore<0)continue;
    var lsType=withoutPrefix.slice(lastUnderscore+1);
    var lsDate=withoutPrefix.slice(secondLastUnderscore+1,lastUnderscore);
    var lsStore=withoutPrefix.slice(0,secondLastUnderscore);
    if(seen[lsStore + '|' + lsDate + '|' + lsType]) continue; // already got from DB
    if(!myStores.includes(lsStore))continue;
    if(storeFilter&&lsStore!==storeFilter)continue;
    if(typeFilter&&lsType!==typeFilter)continue;
    if(from&&lsDate<from)continue;
    if(to&&lsDate>to)continue;
    try{
      var rec=JSON.parse(localStorage.getItem(key)||'{}');
      var answers=rec.answers||{};
      var total=rec.total||Object.keys(answers).length;
      var score=rec.score!=null?rec.score:Object.values(answers).filter(function(a){ return a && a.answer === 'yes'; }).length;
      var pct=total>0?Math.round(score/total*100):0;
      var missed=[];
      Object.entries(answers).forEach(function(e){
        var v=e[1];
        if(!v||(v.answer && v.answer !== 'yes')) missed.push(String(parseInt(e[0])+1));
      });
      rows.push({store:lsStore,date:lsDate,type:lsType,completed:score,total:total,pct:pct,
        submittedBy:rec.staffName||rec.submittedBy||'—',submittedAt:rec.submittedAt||rec.date||'—',missed:missed});
    }catch(e){}
  }
  return rows.sort(function(a,b){return b.date.localeCompare(a.date)||b.type.localeCompare(a.type);});
}

function downloadComplianceCSV(){
  var rows=getComplianceData();
  if(!rows.length){showToast('No data to export','error');return;}
  var csv=['Store,Date,Type,Completed,Total,% Complete,Submitted By,Missed Items'];
  rows.forEach(function(r){
    csv.push(['"'+r.store+'"',r.date,r.type==='open'?'Opening':'Closing',r.completed,r.total,r.pct+'%','"'+(r.submittedBy||'')+'"','"'+r.missed.join('; ')+'"'].join(','));
  });
  var blob=new Blob([csv.join('\n')],{type:'text/csv'});
  var a=document.createElement('a');
  a.href=URL.createObjectURL(blob);
  a.download='ELC_Checklist_Compliance_'+todayDateStr()+'.csv';
  a.click();
  showToast('CSV downloaded','success');
}

function handleAiOverlayClick(e){if(e.target===document.getElementById('aiOverlay'))closeAiPanel();}

async function clearWeeklyRota(){
  var wkStr = localDateStr(currentWeekStart);
  // v136.9 (17 Oct 2026, Matt): CLEAR WEEK KEEPS BOOKED LEAVE. Holiday, sick, APL and TOIL days (the leave guard's
  // types) stay unless the manager ticks "Also clear booked leave" in the confirmation (unticked by default); the
  // server applies the same rule (src/worker/routes/pay.js) and says how many leave days it kept.
  var toDelete = [];
  var leaveKeys = [];
  Object.keys(shifts).forEach(function(key){
    if(key.indexOf(wkStr+'_')!==0) return;
    var sh = shifts[key];
    if(!(sh && sh.workStore === currentStore)) return;
    if(isProtectedLeave(sh)) leaveKeys.push(key); else toDelete.push(key);
  });
  if(toDelete.length===0 && leaveKeys.length===0){
    showToast('No shifts to clear for this week','error');
    return;
  }
  var weekLabelText = document.getElementById('weekLabel').textContent || wkStr;
  // The Shift dialog itself (not window.uiConfirm, which another bundle may have set from an older copy): it is the
  // one that shows the tick box. Without the box (the browser's own confirm) nothing ticks it, so leave is kept.
  var leaveBox = { label: 'Also clear booked leave', checked: false };
  var ask = (typeof sharedConfirm === 'function') ? sharedConfirm : function (m) { return Promise.resolve(confirm(m)); };
  if(!(await ask('Clear all '+toDelete.length+' shifts for '+currentStore+' this week ('+weekLabelText+')?\n\nThis cannot be undone.\nBooked leave (holiday, sick, APL and TOIL days) is kept unless you tick the box below.', { danger: true, confirmLabel: 'Clear', checkbox: leaveBox }))) return;
  var includeLeave = leaveBox.checked === true;
  var clearing = includeLeave ? toDelete.concat(leaveKeys) : toDelete;
  if(clearing.length===0){
    showToast('Nothing cleared: this week only has booked leave, and it was kept.','info');
    return;
  }
  (async function(){
    var attr;
    try {
      attr = await requirePinForAttribution('clearing the weekly rota');
    } catch(e) {
      if(e && e.message === 'Attribution cancelled'){ showToast('Clear cancelled','error'); return; }
      console.error('[clearWeeklyRota] error:', e);
      showToast('Clear failed — see console','error');
      return;
    }
    if(!(typeof DB!=='undefined' && DB.shifts && DB.shifts.clearWeek)){
      showToast('Week not cleared. The rota has not changed. Please try again.','error');
      return;
    }
    // v136.9: the screen changes only once the server has answered (the v136.8 shift-edit rule). It used to clear
    // the screen first and fire the delete in the background, so a failed delete left a week that looked empty on
    // this till while every shift was still in the database. On a failure nothing on screen has changed.
    var btn = document.getElementById('clearWeekBtn');
    if(btn) btn.disabled = true;
    try {
      var res = await DB.shifts.clearWeek(wkStr, currentStore, includeLeave);
      clearing.forEach(function(k){ delete shifts[k]; });
      var kept = (res && typeof res.kept_leave === 'number') ? res.kept_leave : (includeLeave ? 0 : leaveKeys.length);
      if(!includeLeave && kept > 0){
        showToast('Cleared '+clearing.length+' shifts by '+attr.staff_name+'. Booked leave kept: '+kept+' day'+(kept===1?'':'s')+'.','success');
      } else {
        showToast('Cleared '+clearing.length+' shifts from '+currentStore+' by '+attr.staff_name,'success');
      }
      renderCurrentRotaView(); renderClockScreen();
    } catch(e) {
      var m = String((e && e.message) || '');
      if(m === 'Attribution cancelled' || /Authentication required/i.test(m)){ showToast('Clear cancelled','error'); return; }
      console.warn('[DB] Week clear failed:', m);
      showToast('Week not cleared. The rota has not changed. Please try again.','error');
    } finally {
      if(btn) btn.disabled = false;
    }
  })();
}

function csvStartFinish(sh, which) {
  if (!sh) return '';
  if (sh.type === 'work' || !sh.type) {
    // Real work shift — use actual times (or blank if data is missing,
    // which is a legitimate "incomplete shift" state worth surfacing).
    return sh[which] || '';
  }
  if (sh.type === 'oos') {
    // Out of store — surface the destination so the cell is informative.
    return 'OOS' + (sh.oosStore ? ' @ ' + sh.oosStore : '');
  }
  // toil, holiday, sick, off — uppercase the type label
  return String(sh.type).toUpperCase();
}

function exportRotaCSV(){
  var wkStr = localDateStr(currentWeekStart);
  var rows = [];
  Object.keys(shifts).forEach(function(key){
    if (key.indexOf(wkStr + '_') !== 0) return;
    var sh = shifts[key];
    if (!sh || sh.workStore !== currentStore) return;
    // Key shape: YYYY-MM-DD_<staffId>_<day>
    var parts = key.split('_');
    var day = parts[parts.length - 1];
    var sid = parseInt(parts[parts.length - 2], 10);
    if (isNaN(sid)) return;
    var staff = ALL_STAFF.find(function(x){ return x.id === sid; });
    if (!staff) return;
    var dayIdx = DAYS.indexOf(day);
    if (dayIdx < 0) return;
    // v136.8: the cell's real date. The old weekDateStr + DAYS.indexOf(day) offset counted from Monday, so
    // every Qatar row (week starts Sunday) was dated a day early and its Sunday six days late.
    var dateStr = rotaDayDate(wkStr, day);
    // Paid hours: work = on-site minus lunch; TOIL/holiday/sick = 8h (contracted day);
    // off/oos = 0. Rule lives in paidHoursForShift() (above) so it's unit-tested.
    var paidHrs = paidHoursForShift(sh);
    rows.push({
      date: dateStr,
      day: day,
      staff_name: staff.name,
      staff_id: sid,
      role: staff.role || '',
      shift_type: sh.type || 'work',
      // v80.8: non-work shift types don't have start/finish times by
      // design (TOIL/holiday/sick/OOS/off are full-day flags). Showing
      // blank in the CSV reads as "missing data" — Marina Mall reported
      // this on 5 May. Replace blanks with a labelled placeholder so the
      // reader can tell what the shift is about from any column.
      start:  csvStartFinish(sh, 'start'),
      finish: csvStartFinish(sh, 'finish'),
      lunch_at: sh.lunchAt || '',
      lunch_mins: sh.type === 'work' ? (sh.lunch != null ? sh.lunch : 0) : 0,
      paid_hours: paidHrs.toFixed(2),
      notes: sh.notes || '',
    });
  });
  // v129.156 (split shifts) — the day's SECOND legs. Without this the payroll
  // CSV silently UNDERPAYS a split day: a staff member's 28 July would export the
  // stocktake leg only and drop the 3.5h morning. Same row shape; the
  // shift_type names the leg so the payroll reader can see what it is.
  if(typeof shifts2!=='undefined')Object.keys(shifts2).forEach(function(key){
    if (key.indexOf(wkStr + '_') !== 0) return;
    var sh = shifts2[key];
    if (!sh || sh.type !== 'work' || sh.workStore !== currentStore) return;
    var parts = key.split('_');
    var day = parts[parts.length - 1];
    var sid = parseInt(parts[parts.length - 2], 10);
    if (isNaN(sid)) return;
    var staff = ALL_STAFF.find(function(x){ return x.id === sid; });
    if (!staff) return;
    var dayIdx = DAYS.indexOf(day);
    if (dayIdx < 0) return;
    rows.push({
      date: rotaDayDate(wkStr, day),   // v136.8: Qatar-safe, as above
      day: day,
      staff_name: staff.name,
      staff_id: sid,
      role: staff.role || '',
      shift_type: 'work (2nd shift)',
      start:  csvStartFinish(sh, 'start'),
      finish: csvStartFinish(sh, 'finish'),
      lunch_at: sh.lunchAt || '',
      lunch_mins: sh.lunch != null ? sh.lunch : 0,
      paid_hours: paidHoursForShift(sh).toFixed(2),
      notes: sh.notes || '',
    });
  });
  if (rows.length === 0) {
    showToast('No shifts to export for this week', 'error');
    return;
  }
  // Sort by day, then staff name. v136.8: by DATE, so a Qatar week reads Sunday first; a UAE week (Monday
  // first) sorts exactly as the old Mon..Sun order did.
  rows.sort(function(a, b){
    var di = String(a.date).localeCompare(String(b.date));
    if (di !== 0) return di;
    return a.staff_name.localeCompare(b.staff_name);
  });
  // Build CSV — RFC 4180 quoting (fields with commas, quotes, or newlines get quoted + " doubled)
  var headers = ['date','day','staff_name','staff_id','role','shift_type','start','finish','lunch_at','lunch_mins','paid_hours','notes'];
  function csvEscape(v){
    var s = v == null ? '' : String(v);
    if (s.indexOf(',') >= 0 || s.indexOf('"') >= 0 || s.indexOf('\n') >= 0 || s.indexOf('\r') >= 0) {
      return '"' + s.replace(/"/g, '""') + '"';
    }
    return s;
  }
  var lines = [headers.join(',')];
  rows.forEach(function(r){
    lines.push(headers.map(function(h){ return csvEscape(r[h]); }).join(','));
  });
  var csv = lines.join('\r\n');
  // Trigger download
  var blob = new Blob([csv], {type: 'text/csv;charset=utf-8'});
  var url = URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.href = url;
  a.download = 'rota_' + currentStore.replace(/[^a-z0-9]+/gi,'_') + '_' + wkStr + '.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(function(){ URL.revokeObjectURL(url); }, 1000);
  showToast('Exported ' + rows.length + ' shifts', 'success');
}

function toggleRulesPanel(){
  var panel=document.getElementById('rotaRulesPanel');
  var btn=document.getElementById('tabRules');
  var showing=panel.style.display!=='none';
  panel.style.display=showing?'none':'block';
  btn.style.color=showing?'var(--sub)':'var(--rota-green-ink)';
  if(!showing)renderRulesPanel();
}

function renderRulesPanel(){
  var tp;try{tp=JSON.parse(localStorage.getItem('elc_trading_pattern')||'{}');}catch(e){tp={};}
  var country=getStoreCountry(currentStore);
  var isQatar=country==='ELC - Qatar';
  var noDoWeekend=weekendFor(isQatar,tp);   // v133.94
  var allowedDO=tp.allowedDaysOff&&tp.allowedDaysOff.length?tp.allowedDaysOff:['Monday','Tuesday','Wednesday','Thursday'];
  var quietDays=tp.quietDays&&tp.quietDays.length?tp.quietDays:['Monday','Tuesday'];
  var peakDays=peakDaysFor(isQatar,tp);   // v133.94
  var mornSplit=tp.morningSplit||50;
  var evenSplit=100-mornSplit;

  function flag(uae,qatar){
    if(uae&&qatar)return'<span style="font-size:10px">🇦🇪🇶🇦</span>';
    if(uae)return'<span style="font-size:10px">🇦🇪 UAE</span>';
    return'<span style="font-size:10px">🇶🇦 Qatar</span>';
  }
  function rule(icon,text,scope){
    return'<div style="display:flex;align-items:flex-start;gap:8px;padding:5px 0;border-bottom:1px solid var(--border)">'+
      '<span style="flex-shrink:0;font-size:13px">'+icon+'</span>'+
      '<span style="flex:1;color:var(--text);line-height:1.4">'+text+'</span>'+
      '<span style="flex-shrink:0;font-size:10px;color:var(--sub);white-space:nowrap">'+scope+'</span>'+
    '</div>';
  }

  var html='<div style="columns:1;gap:12px">';
  html+=rule('📅','Each person gets <strong>exactly 1 day off</strong> per week. Never two people off on the same day.','Both');
  html+=rule('🚫','Days off <strong>never</strong> on: <strong>'+noDoWeekend.join(', ')+'</strong> (peak weekend trading).',flag(!isQatar,isQatar));
  html+=rule('✅','Days off <strong>permitted</strong> on: '+allowedDO.join(', ')+'.',flag(!isQatar,isQatar));
  html+=rule('💤','<strong>Preferred</strong> days off (quietest): '+quietDays.join(', ')+'. Use these first.','Both');
  html+=rule('📈','<strong>Peak days</strong> (max staffing + late shifts): '+peakDays.join(', ')+'.','Both');
  html+=rule('🕘','Standard shifts: <strong>Early</strong> 09:00–18:00 · <strong>Mid</strong> 13:00–22:00 · <strong>Late</strong> 15:00–24:00. Every shift = 9h on site (8h + 1h lunch).','Both');
  html+=rule('🔀','<strong>Stagger start times</strong> — no two people on the same shift on the same day. Mix early + mid + late.','Both');
  html+=rule('🔒','<strong>Close cover</strong> every day without exception. Weekday close = 22:00. Weekend close = 24:00.','Both');
  html+=rule('🍽','<strong>Stagger lunches</strong> — never same lunchAt twice on same day. Max 1 person on break at a time.','Both');
  html+=rule('💰','Sales split: <strong>'+mornSplit+'%</strong> morning (09–17) vs <strong>'+evenSplit+'%</strong> evening (17–close). '+(evenSplit>=50?'Evening dominant — prioritise mid/late shifts.':'Morning dominant — balance early/late.'),'Both');
  html+=rule('⏱','Max <strong>48h/week</strong> per person (6 days × 8h).','Both');
  if(isQatar&&tp.fridayQatar){html+=rule('🕌','<span translate="no">'+tp.fridayQatar+'</span>','🇶🇦 Qatar');}
  if(tp.otherNotes){html+=rule('📝','<span translate="no">'+tp.otherNotes+'</span>','Both');}
  html+='</div>';
  html+='<div style="font-size:11px;color:var(--sub);margin-top:8px">Edit these rules in the Admin panel → ⚙️ AI Settings tab.</div>';
  document.getElementById('rotaRulesContent').innerHTML=html;
}

// v131.9 (R4c) — the prompt skeleton lives in rota.js (buildRotaPromptCore),
// ONE builder for both apps. The ~100-line local copy that used to be here
// had already drifted from admin's - the v68 drift class at the prompt layer.

async function runAiGenerate(){
  var btn=document.getElementById('aiGenBtn');
  var status=document.getElementById('aiStatus');
  var context=document.getElementById('aiContext').value.trim();
  // v48: Staff roster for this week at this store = home staff + anyone with a
  // shift whose workStore === currentStore and whose home store is different
  // (they've been assigned cover via another manager or a prior edit).
  var homeStaff=getStoreStaff(currentStore);
  var wkStr=localDateStr(currentWeekStart);
  var homeStaffIds={};homeStaff.forEach(function(s){homeStaffIds[s.id]=true;});
  var crossStoreIds={};
  Object.keys(shifts).forEach(function(key){
    if (key.indexOf(wkStr + '_') !== 0) return;
    var sh = shifts[key];
    if (!sh || sh.workStore !== currentStore) return;
    var parts = key.split('_');
    var sid = parseInt(parts[3] || parts[parts.length - 2]);
    if (!isNaN(sid) && !homeStaffIds[sid]) crossStoreIds[sid] = true;
  });
  var crossStoreStaff = Object.keys(crossStoreIds)
    .map(function(id){ return ALL_STAFF.find(function(x){ return x.id === parseInt(id); }); })
    .filter(Boolean);
  var staff=homeStaff.concat(crossStoreStaff);
  // v133.98: who is away which days this week, from the grid: booked leave, work at another store, and a
  // cover person's days at their own store (they were offered all seven before). See ROTA.awayFromCells.
  var weekCells=[];
  Object.keys(shifts).forEach(function(key){
    if (key.indexOf(wkStr + '_') !== 0) return;
    var cell = shifts[key];
    if (!cell) return;
    var rest = key.slice(wkStr.length + 1).split('_');   // staffId_day (a second-shift suffix is ignored)
    var cid = parseInt(rest[0]);
    if (isNaN(cid) || !rest[1]) return;
    weekCells.push({ staffId: cid, day: rest[1], type: cell.type, workStore: cell.workStore, oosStore: cell.oosStore });
  });
  var away=ROTA.awayFromCells(weekCells, homeStaffIds, currentStore);
  var targets=getTargets(currentStore,currentWeekStart);
  var country=getStoreCountry(currentStore);
  var isQatar=country==='ELC - Qatar';
  var holidays=getHolidaysForStore(currentStore);
  // v136.8: each day paired with its REAL date (the Mon-first offset put every Qatar public holiday on the wrong day).
  var weekHolidays=getDisplayDays().map(function(day){var ds=rotaDayDate(wkStr,day);var h=holidays.find(function(x){return x.date===ds;});return h?{day:day,name:h.name}:null;}).filter(Boolean);
  var staffCount=staff.length;

  if(staffCount===0){
    status.innerHTML='\u274C No active staff for this store.';
    return;
  }

  // ── TRADING PATTERN — normalise all day lists to short form ─────
  var tp;try{tp=JSON.parse(localStorage.getItem('elc_trading_pattern')||'{}');}catch(e){tp={};}
  // v131.7 (rota R4) - prefer the SERVER copy at generation time. Boot does
  // refresh localStorage from the DB, but a till that booted offline (or
  // whose config fetch failed) would otherwise generate against stale
  // templates invisibly. Fail-soft: offline here keeps the local copy.
  try {
    var tpFresh = await DB.config.get('trading_pattern');
    if (tpFresh && tpFresh.value) tp = tpFresh.value;
  } catch (e) { /* offline - the boot-time copy stands */ }
  var morningSplit=tp.morningSplit||50;
  var fridayQatar=tp.fridayQatar||'Friday morning in Qatar is quiet until prayer time (~13:30).';
  var otherNotes=tp.otherNotes||'';

  // Shift templates — admin-editable, falls back to defaults
  var templates = getShiftTemplates(tp);

  var noDoWeekendLong=weekendFor(isQatar,tp);   // v133.94: Qatar Friday and Saturday (was a Thursday-Friday default)
  var allowedDOLong=tp.allowedDaysOff&&tp.allowedDaysOff.length?tp.allowedDaysOff:['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var peakDaysLong=peakDaysFor(isQatar,tp);   // v133.94: Qatar Thursday to Saturday (Sunday is a working day there)

  // Convert to short-form for consistency with DAYS, targets, shifts
  var noDoWeekend = noDoWeekendLong.map(toShortDay).filter(Boolean);
  var allowedDO   = allowedDOLong.map(toShortDay).filter(Boolean);
  var peakDays    = peakDaysLong.map(toShortDay).filter(Boolean);

  var deliveryContext=Object.entries(deliveries).filter(function(e){return e[1].length>0;}).map(function(e){return DAY_FULL[e[0]]+': '+e[1].map(function(d){return d.time+(d.note?' ('+d.note+')':'');}).join(', ');}).join('; ');

  // v51: Structured delivery data — earliest arrival time per day (short-form).
  // Used by allocator (cost penalty), prompt (coverage rule), and validator (coverage check).
  var deliveryDayStarts = {};
  Object.entries(deliveries).forEach(function(e){
    var dayShort = e[0]; // already short-form: Mon, Tue, ...
    if (!Array.isArray(e[1])) return;
    e[1].forEach(function(d){
      if (!d || !d.time) return;
      var start = String(d.time).split('-')[0].trim(); // "07:00-09:00" → "07:00"
      if (timeToMin(start) === null) return;
      if (!deliveryDayStarts[dayShort] || timeToMin(start) < timeToMin(deliveryDayStarts[dayShort])) {
        deliveryDayStarts[dayShort] = start;
      }
    });
  });
  // ── STRUCTURED INTAKE (v131.5, R2) ──────────────────────────────
  // Parse the manager's notes into structure BEFORE allocation - a typed
  // day-off request was previously impossible to honour (D/Os were allocated
  // first and declared FIXED to the model; Jessie asked for Tuesday and got
  // Thursday, 28 Aug). FAIL-SOFT: any error here and generation proceeds
  // exactly as before - the notes still ride in the prompt as free text.
  var firstNamesEarly = staff.map(function(s){ return s.name.split(' ')[0]; });
  var requestsByStaffId = {};
  var intakeApplied = null;
  if (context) {
    try {
      var status0 = document.getElementById('aiStatus');
      if (status0) status0.innerHTML = '<div class="ai-dot"></div> Reading your notes...';
      var iRaw = await withTimeout(DB.ai.rota({ purpose: 'rota-intake', model: 'claude-haiku-4-5-20251001', max_tokens: 1000,
        system: 'Output ONLY raw JSON. First character must be {, last must be }.',
        messages: [{ role: 'user', content: buildIntakePrompt(context, firstNamesEarly, getDisplayDays()) }] }), AI_NOTES_LIMIT_MS, 'reading the notes took too long');
      // one parser everywhere (v131.8): tool block or text, null on garbage
      var iParsed = parseRotaResponse(iRaw);
      if (!iParsed) throw new Error('intake returned no JSON');
      intakeApplied = applyIntake(sanitiseIntake(iParsed, firstNamesEarly), deliveryDayStarts, staff);
      deliveryDayStarts = intakeApplied.deliveryDayStarts;
      requestsByStaffId = intakeApplied.requestsByStaffId;
      away = ROTA.mergeAway(away, intakeApplied.awayByStaffId);   // v133.98: "Mahmoud is on holiday", "at Villagio for 6 days"
    } catch (e) { console.warn('[AI rota] intake parse failed - continuing with free text:', e && e.message); intakeApplied = null; }
  }
  var deliveryDaysShort = Object.keys(deliveryDayStarts);

  // ── DETERMINISTIC D/O ALLOCATION ────────────────────────────────
  // ── SHIFT HISTORY (v131.6, R3) ──────────────────────────────────
  // Last 3 PUBLISHED weeks feed the allocator (rotate auto-assigned days
  // off) and the prompt (rotate people off their dominant shift type).
  // FAIL-SOFT: any error and generation runs history-blind, as it always did.
  var historySummary = null;
  var recentDoByStaffId = {};
  try {
    var histRows = [];
    var staffIdSet = {};
    staff.forEach(function (s) { staffIdSet[s.id] = true; });
    for (var hw = 1; hw <= 3; hw++) {
      var wkPrev = localDateStr(new Date(currentWeekStart.getTime() - hw * 7 * 86400000));
      var prevRows = await DB.shifts.list({ week: wkPrev, store: (typeof currentStore !== 'undefined' && currentStore) ? currentStore : undefined });   // v131.38
      (Array.isArray(prevRows) ? prevRows : []).forEach(function (r) {
        if (r && staffIdSet[r.staff_id] && (r.seq || 1) < 2) histRows.push(r);
      });
    }
    historySummary = summariseShiftHistory(histRows, staff, templates);
    staff.forEach(function (s) {
      var rec = historySummary.byStaffId[s.id];
      if (rec && rec.doDays.length) recentDoByStaffId[s.id] = rec.doDays[0];
    });
  } catch (e) { console.warn('[AI rota] history load failed - generating history-blind:', e && e.message); historySummary = null; }
  // v132.100 - COVER CHECK (docs/cover-check-plan.md, Stage 4). When Head
  // Office has set up this country, the generator uses the store's own hours,
  // what each day needs, and days off on the store's own three quietest days
  // (never its two busiest), with targets read by DATE so a Qatar Sunday week
  // is right. Not set up, or any failure: exactly as before. Typed day-off
  // requests still win inside allocateDaysOff.
  var cover = null;
  try { if (typeof CoverView !== 'undefined' && CoverView.generatorContext) cover = await CoverView.generatorContext(); } catch (e) { console.warn('[AI rota] cover check unavailable - generating as before:', e && e.message); cover = null; }
  var coverHours = cover ? cover.hoursByDay : null;
  if (cover && cover.quietDays) { allowedDO = cover.quietDays.slice(); noDoWeekend = cover.busyDays.slice(); targets = cover.targetsByDay; }
  var doByStaffId = allocateDaysOff(staff, targets, allowedDO, noDoWeekend, deliveryDaysShort, requestsByStaffId, recentDoByStaffId, away);

  // Build D/O entries for the final shifts array
  var doEntries = staff.map(function(s){
    var fn = s.name.split(' ')[0];
    var day = doByStaffId[s.id];
    return day ? {staffName:fn, day:day, type:'off'} : null;
  }).filter(Boolean);

  // ── BUILD PROMPT ────────────────────────────────────────────────
  var firstNames = staff.map(function(s){return s.name.split(' ')[0];});
  // App-specific facts travel as DATA into the one shared builder.
  var extraContext = [];
  if (weekHolidays.length) extraContext.push('Public holidays: ' + weekHolidays.map(function(h){ return h.day + ' ' + h.name; }).join(', '));
  if (deliveryContext) extraContext.push('Deliveries: ' + deliveryContext);
  if (isQatar && fridayQatar) extraContext.push(fridayQatar);
  if (otherNotes) extraContext.push(otherNotes);
  var prompt = buildRotaPromptCore({
    store: currentStore,
    // v136.8: the week's own first and last day (Sun to Sat in Qatar); UAE reads exactly as before.
    weekLabel: aiWeekLabel(wkStr, getDisplayDays()),
    staff: staff, firstNames: firstNames, doByStaffId: doByStaffId,
    templates: templates, morningSplit: morningSplit, peakDays: peakDays,
    deliveryDayStarts: deliveryDayStarts,
    awayByStaffId: away,                             // v133.98
    extraContext: extraContext,
    managerNotes: context,
    intakeRules: formatIntakeRules(intakeApplied),
    historyLines: formatHistoryLines(historySummary, staff),
    hoursByDay: coverHours,                          // v132.100 cover check
    coverLines: cover ? cover.coverLines : null,     // v132.100 cover check
  });

  btn.disabled=true;
  var DOTS='<div class="ai-dot"></div><div class="ai-dot"></div><div class="ai-dot"></div>';
  var ticker=startTicker(status, DOTS, 'Your area manager is just looking to create this for you...');   // v133.94: counts up, never a silent wait
  document.getElementById('aiResult').style.display='none';

  // ── HELPER: call AI, parse shifts ───────────────────────────────
  async function callAi(p){
    // v131.8 (R4b) - the model is FORCED onto the rota tool, so the API
    // validates the output shape before we see it. parseRotaResponse still
    // falls back to the old text path if a model ignores the tool.
    var data = await withTimeout(DB.ai.rota({
      purpose:'rota-generate',   // v131.7 - env ROTA_MODEL swaps this with no deploy
      model:'claude-sonnet-4-6',
      max_tokens:4000,
      system:'You are a retail rota planner. Submit the rota by calling the rota tool.',
      messages:[{role:'user',content:p}],
      tools:[rotaOutputTool()],
      tool_choice:{type:'tool',name:'rota'}
    }), AI_CALL_LIMIT_MS, TOO_SLOW);   // v133.94
    var parsed = parseRotaResponse(data);
    if (!parsed) throw new Error('Empty response from AI');
    return parsed;
  }

  // ── VALIDATOR CONTEXT ───────────────────────────────────────────
  // validateRota now lives in rota.js — gather the closure variables it
  // needs into an explicit context object to pass at each call site.
  var rotaCtx = {
    templates: templates,
    firstNames: firstNames,
    staff: staff,
    doByStaffId: doByStaffId,
    deliveryDayStarts: deliveryDayStarts,
    hasManagerNotes: !!(context && context.trim().length),
    historyByStaffId: historySummary ? historySummary.byStaffId : null,   // v131.6 rule 9
    hoursByDay: coverHours,   // v132.100: the store's own closing times, when set up
    awayByStaffId: away,      // v133.98: away days are not working days; a shift on one is critical
  };

  try{
    // ── FIRST ATTEMPT ─────────────────────────────────────────────
    var firstAt = ticker.secs();
    var parsed = await callAi(prompt);
    var workShifts = normaliseShiftLunches((parsed.shifts||[]).filter(function(s){ return s.type!=='off' && s.start; }));
    var v = validateRota(workShifts, rotaCtx);

    // ── RETRY ONCE if critical issues ─────────────────────────────
    // v133.94: unless the first call was already slow: keep its draft (its issues show as warnings)
    if(v.critical.length > 0 && ticker.secs() - firstAt < AI_SKIP_REFINE_SECS){
      ticker.setLabel('Refining...');
      var retryPrompt = prompt + '\n\n'+
        'YOUR PREVIOUS ATTEMPT HAD PROBLEMS:\n'+
        v.critical.map(function(c){return '- '+c;}).join('\n')+'\n'+
        'Please try again and fix these specific issues. Return only JSON.';
      try {
        var parsed2 = await callAi(retryPrompt);
        var workShifts2 = normaliseShiftLunches((parsed2.shifts||[]).filter(function(s){ return s.type!=='off' && s.start; }));
        var v2 = validateRota(workShifts2, rotaCtx);
        // Use retry if it's strictly better
        if(v2.critical.length < v.critical.length){
          parsed = parsed2;
          workShifts = workShifts2;
          v = v2;
        }
      } catch(retryErr) {
        // Retry failed — keep the first attempt
        console.warn('[AI rota] retry failed:', retryErr.message);
      }
    }

    // ── v51: AUTO-FILL MISSING WORK SHIFTS ────────────────────────
    // The AI sometimes drops a shift (saw this in v50 pilot testing: Rocqfel missed Mon).
    // Rather than shipping a rota with gaps that visually look like D/Os, fill any
    // missing (staff, working-day) slot with a sensible default. Prefer the delivery
    // start if it's a delivery day and nobody covered it; otherwise first allowed template.
    // v133.98: a shift the model still put on someone's away day is taken out (and said so) before anything else
    var awayDrop = ROTA.dropAwayShifts(workShifts, staff, away);
    workShifts = awayDrop.kept;
    var autoFills = [];
    awayDrop.dropped.forEach(function(d){ autoFills.push('Removed a shift for ' + d + ': not here that day'); });
    firstNames.forEach(function(name){
      var sMatch = staff.find(function(x){ return x.name.split(' ')[0]===name; });
      if(!sMatch) return;
      var off = doByStaffId[sMatch.id];
      DAYS.forEach(function(day){
        if(day===off) return;
        if(ROTA.isAwayDay(away, sMatch.id, day)) return;   // v133.98: never fill over leave or another store
        var exists = workShifts.some(function(s){ return s.staffName===name && s.day===day; });
        if(exists) return;
        // Pick a shift: if this day has a delivery AND no existing shift covers it, use the delivery slot.
        var arrival = deliveryDayStarts[day];
        // v131.4 — 'covered' means somebody is ON SITE at arrival (a shift
        // spanning it), not somebody starting before it.
        var deliveryUncovered = arrival && !workShifts.some(function(s){
          return s.day===day && s.start && s.finish &&
                 timeToMin(s.start) <= timeToMin(arrival) && timeToMin(s.finish) >= timeToMin(arrival);
        });
        var filled;
        if (deliveryUncovered && deliveryModeForDay(templates, day, arrival, coverHours) === 'early') {
          var arrivalMin = timeToMin(arrival);
          var finishMin  = Math.min(arrivalMin + 540, timeToMin(ROTA.closeFor(day, coverHours)));
          var fh = Math.floor(finishMin/60), fm = finishMin%60;
          filled = {
            staffName: name, day: day,
            start: arrival,
            finish: (fh<10?'0':'')+fh+':'+(fm<10?'0':'')+fm,
            lunchAt: lunchForShift(arrival, (fh<10?'0':'')+fh+':'+(fm<10?'0':'')+fm).lunchAt,
            lunch:   lunchForShift(arrival, (fh<10?'0':'')+fh+':'+(fm<10?'0':'')+fm).lunch,
          };
        } else {
          var allowed = allowedTemplatesForDay(templates, day, coverHours);
          // v131.4 — on a span-mode delivery day, prefer a template that
          // covers the arrival; otherwise the old default (first allowed).
          var tpl = (arrival ? allowed.filter(function(t){
            return timeToMin(t.start) <= timeToMin(arrival) && timeToMin(t.finish) >= timeToMin(arrival);
          })[0] : null) || allowed[0] || templates[0];
          if (!tpl) return; // no templates configured — nothing we can do
          filled = {
            staffName: name, day: day,
            start: tpl.start, finish: tpl.finish,
            lunchAt: computeLunchAt(tpl.start),
            lunch: 60,
          };
        }
        workShifts.push(filled);
        autoFills.push(name+' '+day+': auto-filled '+filled.start+'–'+filled.finish+(deliveryUncovered?' (delivery cover)':' (AI missed this day)'));
      });
    });
    // (The re-validate that used to sit here CRASHED - validateRota(workShifts)
    // with no ctx, the one call site the v68 refactor missed - and fired exactly
    // when auto-fill did, i.e. when the model had dropped a shift. It is
    // replaced by the single final validation below, AFTER lunch optimisation.)

    // ── v51: LUNCH COVERAGE OPTIMISATION ─────────────────────────
    // Recompute lunchAt per day so that each shift's lunch falls while a coworker is on the floor.
    // This is done in-place on workShifts, so downstream merge/publish picks up the new times.
    // Runs even if AI got lunches right — it's idempotent for already-covered lunches.
    DAYS.forEach(function(day){
      var dayShifts = workShifts.filter(function(s){ return s.day===day; });
      // v132.100: with the cover check set up, lunches go in the quietest covered hours.
      optimiseLunchesForDay(dayShifts, cover ? CoverView.needAt(cover, day) : undefined);
    });

    // ── FINAL VALIDATION — of what will actually be shown ─────────
    // The warnings used to be computed BEFORE the lunch optimiser mutated
    // lunchAt, so the manager read a wall of lunch warnings that mostly no
    // longer applied and could not tell which. Validate once, last, after
    // every mutation (retry, auto-fill, lunch optimisation) is done.
    v = validateRota(workShifts, rotaCtx);

    // ── MERGE D/Os + WORK SHIFTS ──────────────────────────────────
    // Stamp type:'work' on each work shift so downstream UI (SPWH table,
    // publish flow) can count them correctly. AI doesn't always include type.
    var workShiftsTyped = workShifts.map(function(s){
      return Object.assign({}, s, {type:'work'});
    });
    // v133.98: away days show on the draft ('away' cells are never published)
    var allShifts = doEntries.concat(ROTA.awayEntries(staff, away, doByStaffId), workShiftsTyped);

    // ── BUILD WARNINGS (advisory + any remaining critical + auto-fills) ─
    var allWarnings = [];
    v.critical.forEach(function(c){ allWarnings.push('❗ '+c); });
    v.advisory.forEach(function(a){ allWarnings.push('⚠️ '+a); });
    autoFills.forEach(function(a){ allWarnings.push('ℹ️ '+a); });
    // v132.100: the cover check on the draft (advice only; never blocks publish).
    if (cover) { try { CoverView.coverWarnings(workShifts, cover).forEach(function(w){ allWarnings.push('🕐 Cover: '+w); }); } catch (e) { /* advice only */ } }
    // Merge AI-supplied warnings if any
    if(parsed.warnings && Array.isArray(parsed.warnings)){
      parsed.warnings.forEach(function(w){ allWarnings.push(w); });
    }

    // ── SANITY: must have at least some work shifts ───────────────
    if(workShifts.length===0){
      throw new Error('AI produced no work shifts — please try again');
    }

    aiDraftShifts = allShifts;
    ticker.stop();
    btn.disabled=false;
    var warnNote = v.critical.length>0
      ? ' — '+v.critical.length+' issue(s) remain, review carefully'
      : (allWarnings.length ? ' — '+allWarnings.length+' note(s)' : '');
    status.innerHTML='\u2705 Done'+warnNote+' — review below then publish';
    // v131.5 — show what the intake UNDERSTOOD, so a mis-parse is visible
    // BEFORE publish rather than discovered in the rota. Escaped: the lines
    // carry manager-typed fragments.
    if (intakeApplied && intakeApplied.understood.length) {
      var eh = (typeof escapeHtml === 'function') ? escapeHtml : function (x) { return String(x); };
      status.innerHTML += '<div style="margin-top:8px;font-size:12px;text-align:start"><strong>Understood from your notes:</strong><br>' +
        intakeApplied.understood.map(function (u) { return '&bull; ' + eh(u); }).join('<br>') + '</div>';
    }
    renderAiDraft({shifts:allShifts, warnings:allWarnings, notes:parsed.notes||'', understood:(intakeApplied?intakeApplied.understood:[])}, staff);

  }catch(err){
    ticker.stop();
    btn.disabled=false;
    status.innerHTML='\u274C '+(err.message||'Something went wrong');
    showToast('Generation failed: '+err.message,'error');
  }
}

function renderAiDraft(parsed,staff){
  var result=document.getElementById('aiResult');result.style.display='block';
  // Entries already carry their own severity icon (set where allWarnings is
  // built) - prepending another here is what doubled the triangles in the
  // 28 Aug screenshots. Admin renders bare; now so does this.
  // v131.10 - the Understood summary lives IN the draft panel, which
  // survives closing and reopening the overlay. It sat in the transient
  // status line before, where an accidental outside-click destroyed it.
  var uBox = document.getElementById('aiUnderstood');
  if (!uBox) {
    uBox = document.createElement('div');
    uBox.id = 'aiUnderstood';
    var wEl = document.getElementById('aiWarnings');
    wEl.parentNode.insertBefore(uBox, wEl);
  }
  if (parsed.understood && parsed.understood.length) {
    var ehU = (typeof escapeHtml === 'function') ? escapeHtml : function (x) { return String(x); };
    uBox.innerHTML = '<div style="background:var(--rota-ok-soft);border:1px solid var(--rota-ok-line);border-radius:10px;padding:10px 12px;font-size:12.5px;margin-bottom:10px">' +
      '<strong>Understood from your notes:</strong><br>' +
      parsed.understood.map(function (u) { return '&bull; ' + ehU(u); }).join('<br>') + '</div>';
  } else { uBox.innerHTML = ''; }
  document.getElementById('aiWarnings').innerHTML=(parsed.warnings||[]).map(function(w){return'<div class="ai-warning">'+escapeHtml(w)+'</div>';}).join('');
  var nBox=document.getElementById('aiNotes');if(parsed.notes){nBox.style.display='block';nBox.textContent='\uD83D\uDCA1 '+parsed.notes;}else nBox.style.display='none';

  // ── SPWH Efficiency Table ──────────────────────────────────
  var targets=getTargets(currentStore,currentWeekStart);
  var displayDays=getDisplayDays();
  var spwhRows=displayDays.map(function(day){
    var target=targets[day]||0;
    var working=(parsed.shifts||[]).filter(function(s){return s.day===day&&s.type==='work';}).length;
    var spwh=working>0?Math.round(target/(working*8)):0;
    var offCount=(parsed.shifts||[]).filter(function(s){return s.day===day&&s.type==='off';}).length;
    var color=spwh>400?'var(--danger)':spwh>250?'#f59e0b':'var(--ok-deep)';
    var dot=spwh>400?'🔴':spwh>250?'🟡':'🟢';
    return '<td style="text-align:center;padding:6px 8px">'
      +'<div style="font-weight:700;font-size:11px">'+day+'</div>'
      +'<div style="font-size:10px;color:var(--sub)">'+(target/1000).toFixed(1)+'k</div>'
      +'<div style="font-weight:700;color:'+color+';font-size:13px">'+spwh+'/h</div>'
      +'<div style="font-size:9px;color:var(--sub)">'+working+' working'+(offCount?' · '+offCount+' off':'')+'</div>'
      +'<div style="font-size:11px">'+dot+'</div>'
      +'</td>';
  }).join('');

  var spwhHtml='<div style="background:var(--surface-2);border-radius:10px;padding:10px 12px;margin-bottom:12px">'
    +'<div style="font-size:10px;font-weight:700;color:var(--sub);text-transform:uppercase;letter-spacing:.5px;margin-bottom:8px">Sales per worked hour (AED/h) — sense check before publishing</div>'
    +'<div style="font-size:10px;color:var(--sub);margin-bottom:8px">🟢 Efficient · 🟡 Review · 🔴 High — consider moving a D/O</div>'
    +'<table style="width:100%;border-collapse:collapse"><tr>'+spwhRows+'</tr></table>'
    +'</div>';

  // Inject SPWH above the table
  var existingSpwh=document.getElementById('aiSpwh');
  if(existingSpwh)existingSpwh.remove();
  var spwhDiv=document.createElement('div');spwhDiv.id='aiSpwh';spwhDiv.innerHTML=spwhHtml;
  var tableWrap=document.getElementById('aiDraftTable').parentNode;
  result.insertBefore(spwhDiv,tableWrap);

  // ── Draft Table ────────────────────────────────────────────
  var table=document.getElementById('aiDraftTable');
  var html='<thead><tr><th>Staff</th>'+displayDays.map(function(d){return'<th>'+d+'</th>';}).join('')+'</tr></thead><tbody>';
  staff.forEach(function(s){
    var firstName=s.name.split(' ')[0];html+='<tr><td translate="no">'+escapeHtml(firstName)+'</td>';   // v132.85
    displayDays.forEach(function(day){
      var sh=(parsed.shifts||[]).find(function(x){return(x.staffName===firstName||x.staffName===s.name||s.name.startsWith(x.staffName)||firstName.startsWith(x.staffName))&&x.day===day;});
      // v51: differentiate "no entry found" from a real D/O entry.
      // With the v51 auto-fill pass upstream, MISSING shouldn't appear in practice —
      // but if it ever does, make it visually loud so the manager can see something's wrong.
      if(!sh){
        html+='<td><span class="ai-draft-off" style="background:var(--rota-danger-soft);color:var(--rota-red-ink);border:1px solid var(--rota-danger-line)">? NO SHIFT</span></td>';
      } else if(sh.type==='away'){   // v133.98: leave, another store, or a cover person's own store
        html+='<td><span class="ai-draft-off" style="background:var(--info-bg);color:var(--info-deep);border:1px solid var(--rota-info-line)" title="'+escapeHtml(sh.reason||'')+'">'+(sh.reason==='on holiday'?'Hol':'Away')+'</span></td>';
      } else if(sh.type&&sh.type.toLowerCase().indexOf('off')>-1){
        html+='<td><span class="ai-draft-off">D/O</span></td>';
      } else if(sh.type==='toil'){
        html+='<td><span class="ai-draft-toil">TOIL</span></td>';
      } else if(!sh.start||!sh.finish){
        html+='<td><span class="ai-draft-off" style="background:var(--rota-danger-soft);color:var(--rota-red-ink);border:1px solid var(--rota-danger-line)">? NO TIMES</span></td>';
      } else {
        html+='<td><span class="ai-draft-shift">'+escapeHtml(sh.start)+'-'+escapeHtml(sh.finish)+'</span></td>';   // v132.89: model output
      }
    });
    html+='</tr>';
  });
  html+='</tbody>';table.innerHTML=html;
  document.getElementById('aiPublishBtn').textContent='\u2705 Publish This Rota';
  document.getElementById('aiPublishBtn').style.background='var(--green)';
  document.getElementById('aiDraftBadge').textContent='DRAFT';
  document.getElementById('aiDraftBadge').className='badge badge-amber';
}

function publishAiRota(){
  if(!aiDraftShifts)return;
  // v48: Every AI-generated shift is at currentStore (that's where we're generating for).
  // Cross-store staff are still included — their shifts record work_store = currentStore
  // so they appear at THIS store's rota, and their home store shows them as OOS.
  // All shifts go to the DB now (no more local-only cover).
  var homeStaff=getStoreStaff(currentStore);
  var allStaff=homeStaff.slice();
  // Include any cross-store staff the generator knew about (scanned from this week's shifts)
  var wkStr=localDateStr(currentWeekStart);
  var homeStaffIds={};homeStaff.forEach(function(s){homeStaffIds[s.id]=true;});
  Object.keys(shifts).forEach(function(key){
    if (key.indexOf(wkStr + '_') !== 0) return;
    var sh = shifts[key];
    if (!sh || !sh.workStore || sh.workStore !== currentStore) return;
    var parts = key.split('_');
    var sid = parseInt(parts[3] || parts[parts.length - 2]);
    if (isNaN(sid) || homeStaffIds[sid]) return;
    if (!allStaff.find(function(x){return x.id===sid;})) {
      var xs = ALL_STAFF.find(function(x){return x.id===sid;});
      if (xs) allStaff.push(xs);
    }
  });

  var dbRows=[];
  var skippedLeave=[];   // v129.62 — booked-leave days the publish KEPT (reported, never silent)
  aiDraftShifts.forEach(function(sh){
    if(sh.type==='away')return;   // v133.98: shown on the draft only; the grid already holds that day
    var s=allStaff.find(function(x){var fn=x.name.split(' ')[0];return fn===sh.staffName||x.name===sh.staffName||x.name.startsWith(sh.staffName)||fn.startsWith(sh.staffName);});
    if(!s)return;
    var sk = wkStr+'_'+shiftKey(s.id,sh.day);
    // v129.62 (pay-critical): a day already holding BOOKED LEAVE (holiday /
    // sick / apl / toil) is never overwritten by an AI publish — skip it
    // untouched (no shifts[sk] write, no dbRow, no TOIL re-deduction) and
    // report it to the publisher below.
    var prior=shifts[sk];
    if(isProtectedLeave(prior)){skippedLeave.push({name:s.name,day:sh.day,type:prior.type});return;}
    var isOff=!sh.start||!sh.finish||(sh.type&&sh.type.toLowerCase().indexOf('off')>-1);
    if(isOff){
      shifts[sk]={type:'off', workStore:currentStore};
      dbRows.push({staff_id:s.id,week_start:wkStr,day:sh.day,type:'off',start_time:null,end_time:null,lunch_at:null,lunch_mins:0,work_store:currentStore,variance_toil:null});
    }
    else if(sh.type==='toil'){
      shifts[sk]={type:'toil', workStore:currentStore};
      dbRows.push({staff_id:s.id,week_start:wkStr,day:sh.day,type:'toil',start_time:null,end_time:null,lunch_at:null,lunch_mins:0,work_store:currentStore,variance_toil:null});
      // v136.8: the real date of that day in THIS store's week (an unknown day still falls back to the week start).
      var toilDateStr=rotaDayDate(wkStr,sh.day);
      addToilTx(s.id,'deduct',8,toilDateStr,'TOIL day taken',true);
    }
    else{
      var pubStart=sh.start||'09:00';var pubFinish=sh.finish||'18:00';
      var pubHrs=(timeMins(pubFinish)-timeMins(pubStart))/60;
      if(pubHrs>9)pubFinish=minsToTime(timeMins(pubStart)+540);
      shifts[sk]={type:'work',start:pubStart,finish:pubFinish,lunch:sh.lunch||60,lunchAt:sh.lunchAt||'13:00',workStore:currentStore};
      // v129.68: variance_toil:null is EXPLICIT — an AI publish over a
      // previously-flagged shift must clear the flag (merge-duplicates would
      // otherwise preserve it onto the new times and credit phantom variance).
      dbRows.push({staff_id:s.id,week_start:wkStr,day:sh.day,type:'work',start_time:pubStart,end_time:pubFinish,lunch_at:sh.lunchAt||'13:00',lunch_mins:sh.lunch||60,work_store:currentStore,variance_toil:null});
    }
  });
  // v136.12 (19 Oct 2026): one row per person and day. The draft can hold two lines for the same person and day
  // (the model put a shift on the day off it was given, or listed a day twice, or two people share a first name
  // and both match the first of them), and two rows with the same key made the server refuse the WHOLE save.
  // The later line wins, which is what the grid above already shows (each line is written over the one before).
  var ddPub=dedupeShiftRows(dbRows);
  if(ddPub.merged){console.warn('[AI rota] publish: '+ddPub.merged+' duplicate day(s) in the draft merged (the later line kept)');}
  dbRows=ddPub.rows;
  // v57: require session PIN for this high-stakes action (publishing the rota).
  // Prompts once per session; thereafter caches.
  (async function() {
    try {
      var attr = await requirePinForAttribution('publishing the rota');
      // Attach attribution to every row BEFORE the DB write
      dbRows.forEach(function(r){
        r.edited_by_staff_id   = attr.staff_id;
        r.edited_by_staff_name = attr.staff_name;
      });
      // Persist to DB
      if(dbRows.length&&typeof DB!=='undefined'){
        // v129.84: the AI publish does NOT send the leave-overwrite flag —
        // the Worker's guard backstops the v129.62 client filter above.
        DB.shifts.save(dbRows, { guardLeave: true }).then(function(){
          dlog('[DB] Published '+dbRows.length+' shifts to DB (by '+attr.staff_name+')');
        }).catch(function(e){console.warn('[DB] Shift publish failed:',e.message);showToast('Warning: shifts saved locally but DB sync failed','error');});
      }
      document.getElementById('aiPublishBtn').textContent='\u2705 Published';
      document.getElementById('aiPublishBtn').style.background='var(--gl)';
      document.getElementById('aiDraftBadge').textContent='PUBLISHED';
      document.getElementById('aiDraftBadge').className='badge badge-green';
      showToast('Rota published for '+currentStore+' — '+dbRows.length+' shifts saved by '+attr.staff_name+(skippedLeave.length?' · '+skippedLeave.length+' leave day'+(skippedLeave.length===1?'':'s')+' kept':''),'success');
      if(skippedLeave.length){setTimeout(function(){showToast(skippedSummary(skippedLeave),'error');},1200);}
      renderRotaWeek();if(currentView==='day')renderDayView();
      // Close panel and go to rota screen
      closeAiPanel();
      switchScreen('rota');
    } catch(e) {
      if (e && e.message === 'Attribution cancelled') {
        showToast('Publish cancelled', 'error');
        return;
      }
      console.error('[publishAiRota] unexpected error:', e);
      showToast('Publish failed — see console', 'error');
    }
  })();
}

// ── re-expose (preserves the pre-extraction global surface) ──
window.renderCurrentRotaView = renderCurrentRotaView;
window.updateWeekLabel = updateWeekLabel;
window.changeWeek = changeWeek;
window.loadFutureWeeksForProjections = loadFutureWeeksForProjections;
window.requireManager = requireManager;
window.executeAction = executeAction;
window.refreshCoverAddStaff = refreshCoverAddStaff;
window.saveCoverAdd = saveCoverAdd;
window.setVarianceReason = setVarianceReason;
window.checkShiftVariance = checkShiftVariance;
window.setShiftType = setShiftType;
window.openShiftModal = openShiftModal;
// v129.156 — the modal's own "second shift" button (editingShift is module-private)
window.openSecondShiftModal = function(){ if(editingShift) openShiftModal(editingShift.staffId, editingShift.day, 2); };
window.requestEditPin = requestEditPin;
window.submitEditPin = submitEditPin;
window.cancelEditPin = cancelEditPin;
window._openShiftModalInner = _openShiftModalInner;
window.closeShiftModal = closeShiftModal;
window.saveShift = saveShift;
window.getWeekHours = getWeekHours;
window.runAiAnalysis = runAiAnalysis;
window.getComplianceData = getComplianceData;
window.downloadComplianceCSV = downloadComplianceCSV;
window.handleAiOverlayClick = handleAiOverlayClick;
window.clearWeeklyRota = clearWeeklyRota;
window.csvStartFinish = csvStartFinish;
window.exportRotaCSV = exportRotaCSV;
window.toggleRulesPanel = toggleRulesPanel;
window.renderRulesPanel = renderRulesPanel;
// window.buildRotaPrompt left in v131.9 - the skeleton lives in rota.js now (buildRotaPromptCore)
window.runAiGenerate = runAiGenerate;
window.renderAiDraft = renderAiDraft;
window.publishAiRota = publishAiRota;

})();
